import { render, staticRenderFns } from "./Shape.vue?vue&type=template&id=7089768a&scoped=true"
import script from "./Shape.vue?vue&type=script&lang=js"
export * from "./Shape.vue?vue&type=script&lang=js"
import style0 from "./Shape.vue?vue&type=style&index=0&id=7089768a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7089768a",
  null
  
)

export default component.exports